// extracted by mini-css-extract-plugin
module.exports = {"root":"PriceFilterPopup_root__1bzVo","label":"PriceFilterPopup_label__1WXd1","labelSelected":"PriceFilterPopup_labelSelected__e_oDV"};